export default __webpack_public_path__ + "static/photochromic-a6141cd3922466bc25271e8e08df4fb0.jpeg";